import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { Button } from './figma/FigmaComponents';

const LiveLinkError = ({ error = "Link expired" }) => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white flex items-center justify-center p-4">
            <div className="max-w-md w-full text-center">
                {/* Logo */}
                <div className="mb-8">
                    <Logo width="208" height="32" textFill="black" />
                </div>

                {/* Error Message */}
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">Access Expired</h2>
                    <p className="text-gray-600 leading-relaxed">
                        This live call link has expired for security reasons. 
                        Please log in to access your dashboard.
                    </p>
                </div>

                {/* Action Button */}
                <Button
                    onClick={() => navigate('/login')}
                    variant="primary"
                    fullWidth
                    className="mb-6"
                >
                    Sign In to Dashboard
                </Button>

                {/* Footer */}
                <div className="pt-6 border-t border-gray-200">
                    <p className="text-sm text-gray-500">
                        Need help? Contact support at{' '}
                        <a href="mailto:support@remote-assistant.ai" className="text-blue-600 hover:underline">
                            support@remote-assistant.ai
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LiveLinkError;